import { Config } from 'config/envConfig';
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { getUrl } from '../components/pdfDisplay/utils';
import { alert, AlertType } from '@quyva/shared-ui';

const FeatureFlagsContext = createContext();

const fetchFeaturesData = async () => {
    try {
        const dynamicUrl = getUrl(
            `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/features/get-features`
        );
        const response = await axios.get(dynamicUrl);
        return response.data;
    } catch (error) {
        console.error('Error fetching feature flags:', error);
        alert(AlertType.ERROR, error.message);
        return null;
    }
};

export const FeatureFlagsProvider = ({ children }) => {
    const [featureFlagsData, setFeatureFlagsData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchFeaturesData();
            setFeatureFlagsData(data);
        };
        fetchData();
    }, []);

    return (
        <FeatureFlagsContext.Provider
            value={{ featureFlagsData, fetchFeaturesData }}
        >
            {children}
        </FeatureFlagsContext.Provider>
    );
};

export const useFeatureFlags = () => {
    return useContext(FeatureFlagsContext);
};
